import { Component, Inject, inject, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PanelGuId, RecaptchaSiteKey, SocialAccount } from '../../../model/constants/AppConstants';
import { CommonService } from '../../../services/common.service';
import { SharedService } from '../../../../services/shared.service';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { ReCaptcha2Component } from 'ngx-captcha';
import { filter } from 'rxjs';
import { JoinComponent } from '../join/join.component';
import { Overlay } from '@angular/cdk/overlay';
import { environment } from '../../../../../environments/environment';
import { TurnstileComponent } from '../../../../static-pages/turnstile/turnstile.component';

declare const google: any;
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [SharedModule, TurnstileComponent],
  templateUrl: './login.component.html'
})
export class LoginComponent {
  constructor(
    public commonService: CommonService,
    public sharedService: SharedService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2,
    private overlay: Overlay
  ) {
    this.getCulture();
  }
  loginForm: FormGroup;
  dialog = inject(MatDialog);
  showPassword: boolean;
  isShowLoader: boolean;
  cultureLanguage: string;
  @ViewChild('turnstile') turnstile!: TurnstileComponent;
  ngOnInit() {
    this.loginFormValue();

        // Check if page is in iframe
     if (window.frameElement) {
      // Redirect to prevent clickjacking
      window.top!.location.href = window.location.href;
    }
  }

  ngAfterViewInit() {

    google.accounts.id.initialize({
      client_id: SocialAccount.googleClient_id,
      callback: (response: any) => this.handleGoogleSignIn(response),
    });

    google.accounts.id.renderButton(
      document.getElementById("googleSignInDiv"),
      {
        theme: 'outline',
        size: 'large',
        text: 'continue_with',
        shape: 'pill',
        type: 'standard',
        logo_alignment: 'center',
        width: 400, // Note: width should be a number, not string
      }
    );

  }

  ngOnDestroy() {

  }

  loginFormValue() {
    this.loginForm = this.commonService.fb.group({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required]),
      reCaptcha: new FormControl('', [Validators.required]),
    })
  };

  async onSubmitLoginForm() {
    this.isShowLoader = true;
    if (this.loginForm.get('reCaptcha')?.invalid) {
      this.isShowLoader = false;
      this.commonService.translate.get('captchaValidation').subscribe((res: string) => {
        this.commonService.userService.showError(res);
      })
      return;
    }
    if (this.loginForm.invalid) {
      this.isShowLoader = false;
      this.loginForm.markAllAsTouched();
      return;
    }
    this.commonService.spinner.show()
    const bodyData = {
      email: this.loginForm.get('email')?.value,
      password: this.loginForm.get('password')?.value.trim(),
      panelGuid: PanelGuId.OpinionEdge,
      v: this.loginForm.get('reCaptcha')?.value
    }
    const loginResponse = await this.commonService.authService.login(bodyData)
    if (loginResponse.success) {
      this.isShowLoader = false;
      this.commonService.spinner.hide()
      this.commonService.storageService.handleStoreData(loginResponse);
      this.commonService.router.navigate(['/dashboard']);
      window.scrollTo(0, 0);
      this.turnstile.reset();
      this.dialog.closeAll();
    } else {
      this.isShowLoader = false;
      this.commonService.spinner.hide()
      // this.loginForm.get('reCaptcha')?.reset()
     this.turnstile.reset();
      this.commonService.translate.get(loginResponse.statusCode).subscribe((res: any) => {
        this.commonService.userService.showError(res);
      })
    }
  }

  openPassword() {
    this.showPassword = !this.showPassword;
  }

  closeDialog() {
    this.dialog.closeAll();
  }
  // Callback Function for Google Sign-In
  async handleGoogleSignIn(response) {
    try {
      const body = {
        credential: response.credential
      }
      // this.homeService.continueWithGoogle(body).then((res: any) => {
      //   if (res.success) {
      //     // Store user details in localStorage
      //     localStorage.setItem('userId', res.data.user_id);
      //     localStorage.setItem('access_token', res.token.token.access.token);

      //     // Redirect user to the desired page
      //     if (!res.data.is_profile_complete) {
      //       this.openDialog();
      //       // this.router.navigate(['/complete-profile', { userId: response.data.data.user_id }]);
      //     } else {
      //       this.router.navigate(['/cart']);
      //     }
      //   } else {
      //     console.error('Login failed:', res.message);
      //   }
      // })
    } catch (error) {
      console.error('Error during Google Sign-In:', error);
    }
  }

  openForgotPassword() {
    this.closeDialog();
    const getClass = this.renderer.selectRootElement('.cdk-overlay-backdrop');
    getClass.classList.add('reset-backdrop');
    this.dialog.open(ForgotPasswordComponent, {
      panelClass: 'forgotPassword-dialog-container',
      height: 'auto',
    })
  }

  openSignUpPage() {
    this.closeDialog()
    this.dialog.open(JoinComponent, {
      panelClass: 'custom-dialog-container',
      id: 'joinCustomDialog',
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      disableClose: true
    });
  }
  loginWithTwitter() {
    this.commonService.authSocialService.loginWithTwitter();
  }

  async getCulture() {
    const item = await this.sharedService.getculter()
    item.pipe(filter((res: any) => !!res?.culture)).subscribe((res: any) => {
      this.cultureLanguage = res.culture?.split('-')[0] || 'en';
    })
  }

  onVerified(token: string) {
    // This method is called when reCAPTCHA is successfully completed
    // this.captchaToken = token;
        console.log(token);

    this.loginForm.get('reCaptcha')?.setValue(token);
  }

  onExpired() {
    // This method is called when reCAPTCHA expires
    // this.captchaToken = null
     this.loginForm.get('reCaptcha')?.reset();
  }

}
